// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","basket":"_3HrJGQ8DUPd9e9ab","search":"_1HUEDIqqTEBuI3Ab","subHeader":"Mu4Xpn-kGS30HF_w"};